import styled from 'styled-components'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState,useEffect } from 'react';
import api from '../axios.js'




const Container=styled.div`
	position:relative;
	background-color:#050505;
	height:100%;
	overflow:auto;
	display:flex;
	flex-direction:column;
	align-items:end;
	&::-webkit-scrollbar{
		display:none;
  	}

 `;



export default function LateralCategorias(props){
	let { filtroConsola,filtroCategorias,filtroPlayers } =props;
	let [ data,setData]=useState([]);
	let [ consola,setConsola ]=useState({ps4:true,ps5:true});
	let [ players,setplayers ]=useState([]);
	let [ categorias,setCategorias ]=useState([]);
	

	useEffect(()=>{		
		try{
			api.get(`/categoria` )
	 	 	.then(response=>response.data)
	 	 	.then(rsp=>{	 	 			
	 	 		let temp=rsp.filter(cat=>cat.activo);
	 	 		setData(temp)})		

	 	 	}catch(err){console.log(err)}
	},[])



	useEffect(()=>{
		let temp=[];
		if(consola.ps4){temp.push("Playstation 4")};
		if(consola.ps5){temp.push("Playstation 5")};
		if (temp.length<1){temp=["PlayStation 4","PlayStation 5"]};
		filtroConsola(temp)
	},[consola,filtroConsola])

	useEffect(()=>{
		let temp=[];
		Object.keys(categorias).forEach(cate=>{if(categorias[cate]){temp.push(cate) } });
		filtroCategorias(temp)		
	},[categorias,filtroCategorias]);

	useEffect(()=>{
		let temp=[];
		if(players["1"]){temp.push("1")};
		if(players["2+"]){temp.push("2+")};
		if (temp.length<1){temp=["1","2+"]};
		filtroPlayers(temp)
	},[players,filtroPlayers]);

	

	let handleChangeConsola=(e,newValue)=>{
		setConsola({...consola,[e.target.id]:e.target.checked  })		
	};

	let handleChangeCategoria=(e,newValue)=>{
		setCategorias({...categorias,[e.target.id]:e.target.checked  })		
	};

	let handleChangePlayers=(e,newValue)=>{
		setplayers({...players,[e.target.id]:e.target.checked  })		
	};

	return(
		<Container style={{width:"16vw",minWidth:210}}>
			   <Accordion defaultExpanded sx={{width:"15vw",minWidth:200}} >
        			<AccordionSummary expandIcon={<ExpandMoreIcon />}  >
          				<Typography>categorias</Typography>
        			</AccordionSummary>
        			<AccordionDetails>
          				{data.map(categoria=><div key={categoria.id} ><FormControlLabel label={categoria.nombre} control={<Checkbox id={categoria.nombre}  onChange={handleChangeCategoria}/>} /></div>)}
        			</AccordionDetails>
      			</Accordion>
      			<Accordion sx={{width:"15vw",minWidth:200}}>
        			<AccordionSummary expandIcon={<ExpandMoreIcon />} >
          				<Typography>Consola</Typography>
        			</AccordionSummary>
        			<AccordionDetails>
          				<div><FormControlLabel label="PlayStation 4"  control={<Checkbox checked={consola.ps4} id="ps4" onChange={handleChangeConsola} />}/></div>
          				<div><FormControlLabel label="PlayStation 5"  control={<Checkbox checked={consola.ps5} id="ps5" onChange={handleChangeConsola} />}/></div>
        			</AccordionDetails>
      			</Accordion>
      			<Accordion sx={{width:"15vw",minWidth:200}}>
        			<AccordionSummary expandIcon={<ExpandMoreIcon />} >
          				<Typography>Players</Typography>
        			</AccordionSummary>
        			<AccordionDetails>
          				<div><FormControlLabel label="1 player"  control={<Checkbox id="1" onChange={handleChangePlayers} />}/></div>
          				<div><FormControlLabel label="2+ players"  control={<Checkbox id="2+" onChange={handleChangePlayers} />}/></div>
        			</AccordionDetails>
      			</Accordion>

		</Container>
		)
}